
import React from 'react';



type Props = {
  className?: string;
}
export const LinkBlankVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = '#0041A0' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M21 13V16C21 17.3261 20.4732 18.5979 19.5355 19.5355C18.5979 20.4732 17.3261 21 16 21H8C6.67392 21 5.40215 20.4732 4.46447 19.5355C3.52678 18.5979 3 17.3261 3 16V8C3 6.67392 3.52678 5.40215 4.46447 4.46447C5.40215 3.52678 6.67392 3 8 3H11' />
      <path stroke = '#0041A0' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M12 12L21 3' />
      <path stroke = '#0041A0' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M16 3H21V8' />
    </svg>
  );
};
